import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { TableCellPositionRecord } from "./TableCellPositionRecord";

export const TableCellGroupRecord = Record({
  topLeft: TableCellPositionRecord,
  bottomRight: TableCellPositionRecord
});

const data = {
  objects: {
    topLeft: "TableCellPositionRecord",
    bottomRight: "TableCellPositionRecord"
  }
};
createFromJS.registerCallback("TableCellGroupRecord", createFromJS.createNestedCallback(TableCellGroupRecord, data));
